<form *ngIf="fields" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate(dialogBoxCivilStatus)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.namenullable}">{{ fields.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="name" pInputText [maxlength]="fields.name.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.descriptionnullable}">{{ fields.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input  type="text" formControlName="description" pInputText [maxlength]="fields.description.width"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.description"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="text-align: center; border: none;">
      <button
      class="k-generic-btn"
      type="submit" pButton
      icon="fa fa-check"
      label="{{('common.save' | translate)}}"
      ></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/civil-status/civil-status-form.html